// extracted by mini-css-extract-plugin
export default {"root":"styles_root__SSKpj","brands":"styles_brands__1roid","wideBrands":"styles_wideBrands__sVcCj","brandsMobile":"styles_brandsMobile__PNnRP"};